import '../../utils/jquery-global'
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes, { func } from 'prop-types';
import paths from '../../paths';
import { getFullGalleryImageUrl } from '../../utils/api/services/image';
import { getGalleryImages } from '../../utils/api/services/gallery';
import BreadCrumbs from '../../components/BreadСrumbs/BreadСrumbs';
import Preloader from '../../components/Preloader/Preloader';
import '@fancyapps/fancybox';


export class GalleryCategoryDetails extends Component {
    constructor(props) {
        super(props);


        this.state = {
            isLoading: true,
            gallery: null
        };
    }

    componentWillMount = () => {
        this.fetchData();
    };

    fetchData = () => {
        this.setState({ isLoading: true });
        getGalleryImages(this.props.match.params.alias)
            .then((result) => {
                console.log(result);
                this.setState({
                    gallery: result
                });
            })
            .catch((e) => {
                console.log(e);
            })
            .finally(() => {
                this.setState({
                    isLoading: false,
                });
            });
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.location.search !== this.props.location.search) {
            this.fetchData();            
        }

        window.$(document).ready(function () {
            window.$("[data-fancybox]").fancybox({
                clickContent: false
            });
        })
    }

    render() {
        const {
            isLoading, gallery,
        } = this.state;


        if (isLoading && !gallery) {
            return <Preloader />;
        }

        return (
            <div className="b-center">
                <BreadCrumbs
                    data={[{ url: paths.advocates.main, text: 'Главная' },
                        { url: paths.advocates.gallery, text: 'Галерея' },
                        { url: `${paths.advocates.gallery}/${gallery.alias}`, text: `${gallery.name}` }]}
                />

                <h1 className="title -primary">{gallery.name}</h1>

                <div className="page-container">
                    {gallery.galleryImages.length ? (
                        <ImagesContent
                            images={gallery.galleryImages}
                        />
                    ) : (
                            <div>Нет изображений</div>
                            )}
                </div>
            </div>
        );
    }
}

const ImagesContent = ({
    images
}) => (
        <React.Fragment>
            <div className="gallery-section">
                {images.length ? (
                    images.map(item => (
                        <a key={item.imageId} href={getFullGalleryImageUrl(item.imageId)} className="gallery-section__item" data-fancybox="gallery" data-caption={item.name}>

                            <div className="gallery-section__item-pic">
                                <img src={getFullGalleryImageUrl(item.imageId)} />								
								</div>
                            <div className="gallery-section__item-desc">
                                {item.name}
								</div>
						</a>

                    ))
                ) : (
                        <div>Нет изображений</div>
                    )}
            </div>
        </React.Fragment>
    );
